<template>
  <div class="slice">
    <div class="wapper">
      <el-card class="rightBox">
        <el-page-header @back="goBack" :content="tabName"></el-page-header>
        <el-card
          class="status_card"
          v-if="
            (prescription_id && listDataType.status === -1) ||
            listDataType.status === -2
          "
        >
          <div class="status_card_content">
            <el-tag
              type="danger"
              class="prescription_type"
              effect="dark"
              size="medium"
              disable-transitions
              ><span class="prescription_status">{{
                listDataType.status_text
              }}</span></el-tag
            >

            <div class="prescription_reason">
              原因：{{ listDataType.prescription_cause }}
            </div>
          </div>
        </el-card>

        <caseDetail :case_id="case_id"></caseDetail>
        <prescription-pdf
          v-if="prescription_id"
          :id="prescription_id"
        ></prescription-pdf>
        <el-button
          class="back-bottom-button"
          v-if="prescription_id"
          type="primary"
          @click="goBack"
          >返回开具处方</el-button
        >
      </el-card>
    </div>
    <Vfooter />
  </div>
</template>

<script>
import { prescriptionDetail } from "@/api";

import caseDetail from "@/components/case/detail";
import Vfooter from "@/components/footer/index";
import prescriptionPdf from "@/components/prescriptionPdf";
export default {
  components: { prescriptionPdf, Vfooter, caseDetail },
  props: {},
  data() {
    return {
      tabName: "病历详情",
      case_id: "",
      sick_im_accid: "",
      prescription_id: "",
      listDataType: {},
    };
  },
  created() {
    this.case_id = this.$route.query.case_id;
    this.sick_im_accid = this.$route.query.sickId;
    this.prescription_id = this.$route.query.prescription_id;
    if (this.prescription_id) {
      this.readyList();
    }
  },
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    detailHandle() {
      this.$router.push({
        path: "/index/user/prescription",
      });
    },
    goBack() {
      console.log("1423123");
      this.$router.go(-1);
      // this.$router.push({
      //     path: "/index/work/chart",
      //     query: {
      //         sessionId: this.$route.query.sessionId
      //     }
      // });
    },
    /**
     * 初次获取数据
     */
    readyList() {
      const that = this;
      const params = {
        id: this.prescription_id,
      };
      prescriptionDetail(params).then(that.readyHandle);
    },
    readyHandle(res) {
      const that = this;
      if (res.code === 1) {
        that.listDataType = res.data;
        //设置导航的消息未读状态
      } else {
        that.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.wapper {
  padding: 20px;
  min-height: 800px;

  .leftBox {
    // flex: 0 0 60%;
  }

  .rightBox {
    // flex: 0 0 38%;
    min-height: 700px;
    margin-left: 20px;
    .back-bottom-button {
      margin: 10px auto;
      display: block;
      width: 400px;
    }
    .status_card {
      float: right;
      width: 400px;
      z-index: 100;
      display: block;
      text-align: center;
      vertical-align: middle;
      position: fixed;
      top: 65px;
      right: 20px;

      .status_card_content {
        margin-bottom: 8px;
      }
      .prescription_type {
        display: inline-block;
        float: left;
        text-align: center;
      }
      .prescription_reason {
        padding: 8px;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>
